import { AchExceptionDetailDataModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { PayOrReturnChoice } from '../../../mappings/ach';

const defaultAchExceptionDetailDataModel: AchExceptionDetailDataModelDto = {
    id: 0,
    updatedDate: '',
    achExceptionDetailId: 0,
    accountId: 0,
    companyId: 0,
    achExceptionDecisionStatusId: 0,
};

export class AchExceptionDetail extends DomainEntity<AchExceptionDetailDataModelDto> {
    public decisionChoice?: string;

    public createDefault(): this {
        return new AchExceptionDetail(defaultAchExceptionDetailDataModel) as this;
    }

    public get achExceptionDetailId() {
        return this.dto.achExceptionDetailId;
    }

    public get accountId() {
        return this.dto.accountId;
    }

    public get companyId() {
        return this.dto.companyId;
    }

    public get achExceptionDecisionStatusId() {
        return this.dto.achExceptionDecisionStatusId;
    }

    public get accountName() {
        return this.dto.accountName;
    }

    public get accountNumber() {
        return this.dto.accountNumber;
    }

    public get accountType() {
        return this.dto.accountType;
    }

    public get amount() {
        return this.dto.amount;
    }

    public get batchNumber() {
        return this.dto.batchNumber;
    }

    public get companyName() {
        return this.dto.companyName;
    }

    public get achCompanyName() {
        return this.dto.achCompanyName;
    }

    public get achCompanyId() {
        return this.dto.achCompanyId;
    }

    public get decisionBy() {
        return this.dto.decisionBy;
    }

    public get decisionDate() {
        return this.dto.decisionDate;
    }

    public get postedDate() {
        return this.dto.postedDate;
    }

    public get entryDescription() {
        return this.dto.entryDescription;
    }

    public get exceptionType() {
        return this.dto.exceptionType;
    }

    public get exceptionItemId() {
        return this.dto.exceptionItemId;
    }

    public get fromWorkStation() {
        return this.dto.fromWorkStation;
    }

    public get secCode() {
        return this.dto.secCode;
    }

    public get protected() {
        return this.dto.protected;
    }

    public get isProtected() {
        return this.dto.protected === 'Y';
    }

    public get id() {
        return this.dto.id;
    }

    public get updatedBy() {
        return this.dto.updatedBy;
    }

    public get updatedDate() {
        return this.dto.updatedDate;
    }

    public toSaveDto() {
        let statusId = PayOrReturnChoice.Unselected;
        if (this.decisionChoice === 'Pay') {
            statusId = PayOrReturnChoice.Pay;
        }
        if (this.decisionChoice === 'Return') {
            statusId = PayOrReturnChoice.Return;
        }

        return {
            ...this.dto,
            decisionChoice: this.decisionChoice,
            decisionReviewLabel: this.decisionChoice,
            achExceptionDecisionStatusId: statusId,
        };
    }
}
